import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../../styles/about/timeline.css';

const Timeline = () => {
	return (
		<div className="timeline">
			<span className="timeline-info">
				<h2>Why ProMS is Important</h2>
				<p>
					Sweden is a pioneer in proteomics, with infrastructures like BioMS and
					SciLifeLab, and a history of clinical proteomics integration at
					Karolinska University Hospital.
				</p>
				<p>
					Despite advances in genomics and imaging, proteomics data remain
					underutilized. ProMS fills this gap, connecting molecular phenotyping
					with genomics and imaging to redefine cancer precision medicine.
				</p>
			</span>
			<VerticalTimeline>
				<VerticalTimelineElement
					date="2005"
					iconStyle={{ background: '#007bff', color: '#fff' }}
				>
					<h3>First clinical proteomics unit established.</h3>
				</VerticalTimelineElement>
				<VerticalTimelineElement
					date="2022"
					iconStyle={{ background: '#007bff', color: '#fff' }}
				>
					<h3>Routine diagnostics integrated with proteomics.</h3>
				</VerticalTimelineElement>
				<VerticalTimelineElement
					date="2023"
					iconStyle={{ background: '#007bff', color: '#fff' }}
				>
					<h3>Harmonized national platform developed between KI, GU and LU.</h3>
				</VerticalTimelineElement>
			</VerticalTimeline>
		</div>
	);
};

export default Timeline;
